<ng-container *transloco="let t; read: 'service-command-editor-exec-ivr'">
  <p-messages severity="info">
    <ng-template pTemplate>
      <p class="wrap">{{ t('description') }}</p>
    </ng-template>
  </p-messages>

  <form [formGroup]="form">
    <div class="field col-12 mt-3">
      <p>{{ t('selectIvrLabel') }}</p>
      <app-ivr-autocomplete
        [formControl]="ivrId"
        [placeholder]="t('execIvrSelectPlaceholder')"
      ></app-ivr-autocomplete>
      <p *ngIf="ivrId.hasError('required')" class="p-error">{{ t('ivrIdErrorRequired') }}</p>
    </div>
  </form>
</ng-container>
